<template>
  <div>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <b-container>
        <b-row align-h="center">
          <b-col md="12">
            <b-form @submit.prevent="submitAirdrop">
              <b-row class="bg-white shadow p-5">
                <b-col md="6" class="mb-4">
                  <b-form-group id="input-group-1" label="Select Currency:" label-for="currencyList">
                    <multiselect v-model.trim="$v.form.currencyList.$model" track-by="symbol" label="symbol"
                      :options="slctCurrency" placeholder="Select Currency"></multiselect>
                  </b-form-group>
                  <div class="error" v-if="submitted && !$v.form.currencyList.required">
                    Currency is required
                  </div>
                </b-col>
                <!-- Currency list  -->

                <b-col md="6" class="">
                  <b-form-group id="input-group-1" label="Amount:" label-for="ammount"></b-form-group>
                  <b-form-input id="amount" v-model="$v.form.amount.$model" type="text" onpaste="return false"
                    @keypress="keyChange($event, 8)" placeholder="Enter Amount">
                  </b-form-input>
                  <div class="error" v-if="submitted && !$v.form.amount.required">
                    Amount is required
                  </div>
                </b-col>
                <!-- Amount  -->
                <b-col md="12" class="mb-4">
                  <b-form-group id="input-group-1" label="Select User List:" label-for="userList">
                    <DataTable :value="customers" :lazy="true" :paginator="true" class="p-datatable-responsive"
                      :rows="per_page" :totalRecords="totalRows" @page="onPage($event)" @sort="onSort($event)"
                      dataKey="id" :filters="filters" :loading="loading" 
                      :selection.sync="selectedRows"
                      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                      :rowsPerPageOptions="[10, 25, 50]"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                      <template #empty> No record found. </template>
                      <template #loading> Loading data. Please wait. </template>
                      <Column selectionMode="multiple" headerStyle="width: 32px;text-align:center;"></Column>
                      <Column header="Name" :sortable="true" sortField="name" filterField="name"
                        filterMatchMode="contains">
                        <template #body="slotProps">
                          {{ slotProps.data.name }}
                        </template>
                        <template #filter>
                          <InputText type="text" v-model="filters.name" @keydown.enter="topFilter(filters.name, 'name')"
                            class="p-column-filter" placeholder="Search by name" />
                        </template>
                      </Column>
                      <Column header="Email" :sortable="true" sortField="email" filterField="email"
                        filterMatchMode="contains">
                        <template #body="slotProps">
                          <!-- <span class="p-column-title">Email</span> -->

                          {{ slotProps.data.email }}
                        </template>
                        <template #filter>
                          <InputText type="text" v-model="filters.email"
                            @keydown.enter="topFilter(filters.email, 'email')" class="p-column-filter"
                            placeholder="Search by email" />
                        </template>
                      </Column>
                      <!-- </Column> -->
                    </DataTable>
                  </b-form-group>
                  <!-- <div class="error" v-if="submitted && !$v.form.userList.required">
                    User is required
                  </div> -->
                </b-col>

                <b-col md="12" class="mb-4 text-center">

                  <b-button type="button" class="col-md-2" variant="primary" v-if="loader">
                    <b-spinner label="Spinning"></b-spinner>
                  </b-button>
                  <b-button type="submit" class="col-md-2" variant="primary" v-else>Submit</b-button>


                </b-col>
                <!-- Submit Button  -->
              </b-row>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
    </Layout>
  </div>
</template>

<script>

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
// import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import ApiClass from "../../api/api";
import Swal from "sweetalert2";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
// import Checkbox from 'primevue/checkbox';

export default {
  // page: {
  //     title: "Add New User",
  //     meta: [{ name: "description", content: appConfig.description }],
  // },
  components: {
    Layout,
    Multiselect,
    PageHeader,
    DataTable,
    Column,
    InputText,
    // Checkbox
  },

  data() {
    return {
      
      title: "Airdrop",
      items: [
        {
          text: "Dashboard",
          href: "/admin",
        },
        {
          text: "Assign Crypto",
          active: true,
        },
      ],

      slctTemp2: null,
      slctUsers: [],
      slctCurrency: [],
      selectedRows:[],
      //slctAmountType:['deduct','add'],
      // slctAmountType: [{ name: "deduct" }, { name: "add" }],
      submitted: false,
      multiple:"multiple",
      form: {
        // userList: "",
        currencyList: "",
        amount_type: "",
        amount: "",
      },
      filters: {
        name: null,
        email: null,
        
      },
      filter: "",
      totalRows: 1,
      per_page: 10,
      page: 1,
      loading: true,
      customers: [],
      loader:false

    };

  },
  validations: {
    form: {
      // userList: { required },
      currencyList: { required },
      // amount_type: { required },
      amount: { required },
    },
  },
  created() {
    this.getSelectdata();
    this.client();
  },
  methods: {
    async client() {
      await ApiClass.getRequest(
        "admin/users/get?per_page=" +
        this.per_page +
        "&page=" +
        this.page +
        "&" +
        this.filter
      ).then((res) => {
        // console.log("result=", res);
        if (res.data.status_code == 1) {
          this.loading = false;
          this.customers = res.data.data.data;
          // console.log("rahul" + this.customers);
          this.currentPage = res.data.data.current_page;
          this.totalRows = res.data.data.total;
          // console.log("users/get" , this.customers );
        }
      });
    },

    onPage(event) {
      if (this.page != event.page + 1) {
        this.loading = !this.loading;
        this.page = event.page + 1;
        this.client();
      }
    },

    onSort(e) {
      this.loading = !this.loading;
      var sortby = e.sortOrder == 1 ? "asc" : "desc";
      this.filter = "sortby=" + sortby + "&sortbyname=" + e.sortField;
      this.client();
    },

    topFilter(columnVal, columnName) {
      //  if(columnName == 'status'){

      //          columnVal = columnVal == 'verified' ? true : false;
      //      }
      // if (columnName == "date") {
      //   columnVal = columnVal.toLocaleDateString("es-US").split("T")[0];
      //   columnVal = columnVal.replaceAll("/", "-");

      //   columnVal = columnVal.split("-").reverse().join("-");
      // }
      this.loading = !this.loading;

      this.$set(this.filters, columnName, columnVal);

      var x = this.filters;
      const resulted = JSON.parse(JSON.stringify(x), (key, value) =>
        value === null || value === "" ? undefined : value
      );

      let query = new URLSearchParams(resulted).toString();

      this.filter = query;

      this.client();
    },
    async getSelectdata() {
      var result = await ApiClass.getRequest("admin/fund/get_fund", true);
      if (result.data.status_code == 1) {
        // console.log(result);
        // console.log(result.data.data.users);
        // this.slctUsers = result.data.data.users;
        this.slctCurrency = result.data.data.currencyList;
          //  this.currentPage = res.data.data.current_page;
          // this.totalRows = res.data.data.total;
      }
    },
    async submitAirdrop() {
      console.log(this.selectedRows);
      this.submitted = true;
      if (this.$v.$invalid) {
        return;
      }
      this.submitted = false;
      if (this.selectedRows.length == 0) { 
       return Swal.fire({
          position: "center",
          icon: "error",
          title: 'No user selected yet.....',
          showConfirmButton: false,
          timer: 1000,
        });
      }
      let user_id = this.selectedRows.map((ele) => { return { id  : ele.id } });
      console.log(user_id);
      this.loader = true;

      var result = await ApiClass.postRequest("admin/fund/addairDrop", true, {
        user_id: user_id,
        currency: this.form.currencyList.symbol,
        amount: this.form.amount,       
      });
      console.log(result);
      if (result.data.status_code == 1) {
        this.reset();
        Swal.fire({
          position: "center",
          icon: "success",
          title: result.data.message,
          showConfirmButton: false,
          timer: 1000,
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: result.data.message,
          showConfirmButton: false,
          timer: 1000,
        });
      }
      this.loader = false;

      if(result.data.status_code == 1){
        this.$router.push({ name: 'airDropGet' })
       }
    },
    reset() {
      this.form = {
        // userList: "",
        currencyList: "",
        ammount: "",
        // amount_type: "",
      }; // Empty Fields
    },

    keyChange(event, decimal = null) {
      let res =
        (event.charCode >= 48 && event.charCode <= 57) ||
        (event.charCode == 46 && event.target.value.indexOf(".") == -1);

      if (decimal != null && res && event.target.value.indexOf(".") != -1) {
        res = event.target.value.split(".")[1].length < decimal;
      }
      return res ? res : event.preventDefault();
    },
  },
};
</script>